import React from 'react';
import style from './RecoveryPassPage.module.scss';
import Logo from '../UI/Logo/Logo';
import Preloader from '../UI/Preloader/Preloader';
import GoBackBtn from '../UI/GoBackBtn/GoBackBtn';

const RecoveryPassPage = (props) => {
  const [email, setEmail] = React.useState('');
  const [isPreloading, setIsPreloading] = React.useState(false);
  const [message, setMessage] = React.useState('');

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsPreloading(true);

    } catch (err) {
      console.log(`Something failed: ${err}`);
      setMessage('ERROR');
    } finally {
      setIsPreloading(false);

    }
  }

  if (isPreloading) {
    return <Preloader />
  }

  return (
    <div>

      <div className={style.wrap}>
        <div className={style.btn_back_container}>
          {/* <GoBackBtn link={'/login'} /> */}
          <GoBackBtn />
        </div>
        <form action="" className={style.main_form}
          onSubmit={handleSubmit}>
          <div className={style.logo_container}>
            <Logo />
          </div>
          <div className={style.title_container}>
            <div className={style.title}>Restore password!</div>
          </div>

          <div className={style.inputs_container}>
            <label htmlFor="email">
              <input type="email" name="email" id="email"
                placeholder='E-mail'
                value={email}
                onChange={(e) => { setEmail(e.target.value) }} />
            </label>
          </div>

          <div className={style.button_container}>
            <button disabled="" type="submit" className={`${style.btn} ${style.btn__main}`}>
              <span>Recovery</span>
            </button>
          </div>
        </form>
        {message && <div className={style.message}>{message}</div>}
      </div>


      {/* <div className={style.logo} >
        <Logo/>
      </div>
      <div className={style.account_intro_page}>
        <div className={style.account_intro_page_overlay}>
          <div className={style.account_intro_page_container}>
            <div className={style.account_intro_page_row}>
              <form action="" className={style.main_form} autoComplete="off">
                <div className={style.form_title}>
                  Restore password
                </div>
                  <div className={style.input_group}>
                    <input type="email" name="email" id="_email" />
                    <label htmlFor="_email" className={style.placeholder_label}>E-mail</label>
                  </div>
                  <div className={style.buttons_container}>
                    <div className={style.submit_container}>
                      <button disabled="" type="submit" className={`${style.ant_btn} ${style.btn}`}>
                        <span>Recovery</span>
                      </button>
                    </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default RecoveryPassPage;